module.exports = __webpack_public_path__ + "media/src/images/icons/more/button-5f1d847c15f115e4eca62f016ce8ef66.svg";